import React, { useRef, useState } from 'react';
import { supabase } from '../lib/supabase';
import { fileName } from '../utils/helpers';

export default function FileUpload({ label, value, onChange, required, accept = '.pdf,.jpg,.jpeg,.png' }) {
  const ref = useRef();
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState('');
  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true); setErr('');
    const path = 'uploads/' + Date.now() + '_' + file.name.replace(/\s+/g, '_');
    const { error } = await supabase.storage.from('payment-docs').upload(path, file);
    if (error) setErr('Upload failed: ' + error.message);
    else onChange(path);
    setUploading(false);
  };
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#444', marginBottom: 6 }}>
        {label}{required && <span style={{ color: '#A32D2D', marginLeft: 3 }}>*</span>}
      </label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <button type="button" onClick={() => ref.current.click()} disabled={uploading}
          style={{ padding: '7px 14px', background: '#f5f4f0', border: '1px solid #d3d1c7', borderRadius: 8, fontSize: 13, cursor: uploading ? 'not-allowed' : 'pointer', color: '#444' }}>
          {uploading ? 'Uploading…' : '📎 Choose file'}
        </button>
        <input ref={ref} type="file" accept={accept} onChange={handleFile} style={{ display: 'none' }} />
        {value && !uploading && <span style={{ fontSize: 12, color: '#3B6D11', fontWeight: 500 }}>✓ {fileName(value)}</span>}
        {!value && !uploading && <span style={{ fontSize: 12, color: '#aaa' }}>No file chosen</span>}
      </div>
      {err && <div style={{ fontSize: 12, color: '#A32D2D', marginTop: 4 }}>{err}</div>}
    </div>
  );
}
